/** A ref-shaped flag so a second click cannot start before React re-renders. */
export type MoveGate = { current: boolean };

/**
 * Claim the in-flight move. False when one is already running, so two page
 * updates stay one operation instead of overlapping reorders.
 */
export function tryBeginMove(gate: MoveGate): boolean {
  if (gate.current) return false;
  gate.current = true;
  return true;
}

export function endMove(gate: MoveGate): void {
  gate.current = false;
}
